const stars = () => {
  var bodyHeight = $("body").outerHeight();

  if (!document.querySelector('.team') && window.innerWidth > 768) {
    $("#stars").css("height", bodyHeight + "px");
  }

  particlesJS("stars", {
    particles: {
      number: {
        value: 250,
        density: {
          enable: true,
          value_area: 1300,
        },
      },
      color: {
        value: "#ffffff",
      },
      shape: {
        type: "circle",
      },
      opacity: {
        value: 1,
        random: true,
        anim: {
          enable: true,
          speed: 0.35,
          opacity_min: 0.3,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      size: { value: 2, random: true },
      move: {
        enable: true,
        speed: 0.5,
        direction: "left",
      },
    },
  });

  if(window.innerWidth > 768) {
    particlesJS("stars2", {
      particles: {
        number: {
          value: 250,
          density: {
            enable: true,
            value_area: 1300,
          },
        },
        color: {
          value: "#ffffff",
        },
        shape: {
          type: "circle",
        },
        opacity: {
          value: 0.5,
          random: true,
          anim: {
            enable: true,
            speed: 0.5,
            opacity_min: 0,
            sync: false,
          },
        },
        line_linked: {
          enable: false,
        },
        size: { value: 2, random: true },
        move: {
          enable: true,
          speed: 0.35,
          direction: "left",
        },
      },
    });
  }

  function createFallingMeteor() {
    const meteors = document.querySelectorAll(".metor");

    meteors.forEach((meteor, index) => {
        const randomX = Math.random() * (window.innerWidth - 10);
        const randomY = Math.random() * (window.innerHeight - 100);
        const randomNumber = Math.floor(Math.random() * 4) + 1; 
        
        meteor.style.left = index % 2 === 0 ? `${randomX}px` : "auto";
        meteor.style.right = index % 2 === 1 ? `${randomX}px` : "auto";
        meteor.style.top = `${randomY}px`;

        meteor.style.opacity = "0";
        meteor.style.animation = "none";

        meteor.offsetHeight;

        meteor.style.animation = `trajectory${randomNumber} 0.4s linear forwards`;
        meteor.style.opacity = "1";

        setTimeout(() => {
            meteor.style.opacity = "0";
        }, 500); 
    });
}

setInterval(createFallingMeteor, 5000);


};

export default stars;
